export default "__VITE_ASSET__B5wuza2I__"